import { render, staticRenderFns } from "./ChargebackSummary.vue?vue&type=template&id=4ffdf8ae"
import script from "./ChargebackSummary.vue?vue&type=script&lang=js"
export * from "./ChargebackSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports